/* eslint-disable camelcase */

/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import AskCreateTemplateIcon from '../../../assets/DisputeNotification.png';
import CreatedTemplateIcon from '../../../assets/TemplateCreatedSuccessIcon.png';
import WarningIcon from '../../../assets/property_warning.png';
import ErrorIcon from '../../../assets/stalledIcon.png';
import { ControlDialogBox } from '../../../components/controlDialogBox/ControlDialogBox';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import MultiFileUploadPreview from '../../../components/fileUploads/MultiFileUploadPreview';
import MultiFileViewer from '../../../components/fileUploads/MultiFileViewer';
import { useGetCaCategoriesQuery } from '../../../pages/correctiveActions/correctiveActionsSlice';
import { selectCurrentEmpid, selectCurrentIsHC, selectCurrentUser } from '../../../pages/login/authSlice';
import {
    AssignmentTabIndex,
    CaApprovalAction,
    CaStatus,
    CaStatusNames,
    MyDashboardCA,
} from '../../../utils/typeConstants';
import {
    useGetCaSeverityLevelQuery,
    useGetCaTemplateLanguageQuery,
} from '../configureCorrectiveActionTemplate/CaConfigure.slice';
import { caDetails, CorrectiveActionDocument } from '../type';
import { CaHistory } from './CaHistory';
import './CaManagerTlView.scss';
import {
    useCreateCorrectiveActionMutation,
    useDeleteCaDocumentMutation,
    useGetCaDocumentsQuery,
    useGetCaEmployeesQuery,
    useGetCaManagerTlSearchQuery,
    useGetCaNoticeQuery,
    useGetCorrectiveActionQuery,
    useGetMisConductQuery,
    useGetSubCategoriesQuery,
    useUpdateCorreciveActionMutation,
} from './CaMangerTLView.slice';
import { CaButton } from './caButton';
import { EmployeeFilter } from '../../../components/filters/employeeFilter/EmployeeFilter';
import { useGetUserByIDQuery } from '../../../components/scoreCardFilter/scoreCardFilterSlice';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';
import { useLinkCorrectiveActionToCapMutation, useCalculateNextBestActionAssociateMutation } from '../../coachingAction/coachingActionPlanSlice';

interface CaMangerTlProps {
    view: boolean;
    selectedEmployee: caDetails | undefined;
    via?: string;
    getDetails: boolean;
    type: string;
    setActiveIndex?: (e: number) => void;
    handleCloseDialog?: () => void;
    fromCAP?: boolean;
    coachingActionPlanId?: number;
    scorecardVersionId?: number;
}
/* eslint-disable max-len */
export const CaMangerTl = (props: CaMangerTlProps) => {
    const [askcreateTempDialogVisible, setAskcreateTempDialogVisible] = useState<boolean>(false);
    const [createdSuccessTempdialogVisible, setCreatedSuccessTempdialogVisible] = useState<boolean>(false);
    const [selectedCategory, setSelectedCategory] = useState<string>();
    const [AssignCorrectiveAction] = useCreateCorrectiveActionMutation();
    const [UpdateCorrectiveAction] = useUpdateCorreciveActionMutation();
    const [selectedSeverityLevel, setSelectedSeverityLevel] = useState<string>();
    const [selectedSubCategory, setSelectedSubCategory] = useState<string>();
    const [description, setDescription] = useState<string>();
    const [comments, setComments] = useState<string>();
    const [subCategories, setSubcategories] = useState<any>();
    const [notice, setNotice] = useState<string>('');
    const [noticeDescription, setNoticeDescription] = useState('');
    const [isSave, setIsSave] = useState<boolean>(false);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const loggedUser = useSelector(selectCurrentUser);
    const isHC = useSelector(selectCurrentIsHC);
    const [newStartDate, setNewStartDate] = useState(new Date());
    const [categories, setCategories] = useState<any>([]);
    const [languages, setLanguages] = useState<any>([]);
    const [sevierityLevel, setSevierityLevel] = useState<any>([]);
    const [employees, setEmployees] = useState<any>();
    const [selectedEmployee, setSelectedEmployee] = useState<any>(undefined);
    const [correctiveActionId, setCorrectiveActionId] = useState<number>(0);
    const [selectedCountry, setSelectedCountry] = useState<any>('');
    const [statusId, setStatusId] = useState<any>('');
    const [icon, setIcon] = useState<any>();
    const [selectedLanguage, setSelectedLanguage] = useState<any>();
    const [warningMessage, setWarningMessage] = useState<string>('');
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [successHeader, setSuccessHeader] = useState<string>('');
    const [noticeDetails, setNoticeDetails] = useState<any>('');
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const [status, setStatus] = useState<any>();
    const [disabled, setDisabled] = useState<boolean>(false);
    const [issuedDuringTraining, setIssuedDuringTraining] = useState<boolean>(false);
    const [uploadFiles, setUploadFiles] = useState<File[]>([]);
    const [fileErrorDialogVisible, setFileErrorDialogVisible] = useState(false);
    const [fileErrors, setFileErrors] = useState<string[]>([]);
    const [DeleteCaDocument] = useDeleteCaDocumentMutation();
    const [userCanDeleteFiles, setUserCanDeleteFiles] = useState<boolean>(false);
    const [misconduct, setMisconduct] = useState<any>();
    const [selectedMisconduct, setSelectedMisconduct] = useState<string>();
    const [selectedEmployeeNoByHC, setSelectedEmployeeNoByHC] = useState<string>('');
    const [linkCorrectiveActionToCap] = useLinkCorrectiveActionToCapMutation();
    const [calculateNextBestAction] = useCalculateNextBestActionAssociateMutation();

    const { data: caDocumentsData, isLoading } = useGetCaDocumentsQuery(
        { correctiveActionId },
        { skip: !correctiveActionId }
    );

    const files = caDocumentsData?.data || [];

    const { data: allEmployees } = useGetCaEmployeesQuery(
        {
            employeeNumber: loggedEmpNum,
        },
        {
            skip: props.view,
        }
    );
    const { data: allCategories } = useGetCaCategoriesQuery();
    const { data: allSubCategories } = useGetSubCategoriesQuery(
        {
            categoryId: [Number(selectedCategory)],
        },
        {
            skip: !selectedCategory,
        }
    );
    const { data: allsevierityLevel } = useGetCaSeverityLevelQuery(
        {
            countryId: selectedCountry,
            misconductId: selectedMisconduct ?? 0,
            isHCUser: isHC,
        },
        {
            skip: !selectedCountry,
        }
    );

    const { data: allLanguages } = useGetCaTemplateLanguageQuery(
        {
            countryId: selectedCountry,
            categoryId: selectedCategory,
            scorecardRoleId: selectedEmployee?.employee_role_id,
        },
        { skip: !selectedCategory || !selectedCountry || !selectedEmployee?.employee_role_id }
    );

    const { data: noticeData } = useGetCaNoticeQuery(
        {
            categoryID: selectedCategory,
            severityLevelID: selectedSeverityLevel,
            empLanguageID: selectedLanguage,
            countryID: selectedCountry,
            empRoleId: selectedEmployee?.employee_role_id,
        },
        {
            skip:
                !selectedCategory ||
                !selectedSeverityLevel ||
                !selectedLanguage ||
                !selectedEmployee?.employee_role_id ||
                (props.type !== 'add' && props.type !== 'update' && props.type !== 'view'),
        }
    );

    const { data: correctiveActionView, isLoading: isLoadingCorrectiveActionView } =
        useGetCorrectiveActionQuery(
            {
                correctiveActionId: props.selectedEmployee?.corrective_action_id,
            },
            {
                skip: !props.getDetails,
            }
        );
    const { data: caMangerTlData } = useGetCaManagerTlSearchQuery(
        {
            employeeNumber: selectedEmployee?.employeeNumber,
        },
        {
            skip: !selectedEmployee?.employeeNumber,
        }
    );
    const { data: misconductData } = useGetMisConductQuery(
        {
            categoryId: selectedCategory ? [Number(selectedCategory)] : null,
            countryId: selectedCountry,
        },
        {
            skip: !selectedCountry,
        }
    );
    const { data: employeeData } = useGetUserByIDQuery(
        {
            filterParam: selectedEmployeeNoByHC,
            searcherEmpNo: loggedEmpNum,
            getAllEmps: true,
        },
        { skip: !selectedEmployeeNoByHC || !loggedEmpNum }
    );
    useEffect(() => {
        if (props.selectedEmployee) {
            const obj = {
                employeeName: props.selectedEmployee?.employee_name,
                employeeNumber: props.selectedEmployee?.employee_number,
                employeeRole: props.selectedEmployee?.scorecard_role_name,
                employee_role_id: props.selectedEmployee?.scorecard_role_id,
                country_name: props.selectedEmployee?.country_name,
                authorEmployeeName: props.selectedEmployee?.author_employee_name,
                authorEmployeeNumber: props.selectedEmployee?.author_employee_number,
                supervisorName: props.selectedEmployee?.author_employee_name?.split('(')[0] || '',
            };
            setSelectedEmployee(obj);
        }
        if (props.via === 'tab') {
            setShowDetails(false);
        } else {
            setShowDetails(true);
        }
    }, []);

    useEffect(() => {
        if (allEmployees && allEmployees?.data.length > 0) {
            const data = allEmployees.data.map((item: any) => {
                return {
                    ...item,
                    employeeNumber: item.employee_number,
                    employeeName: item.employee_name,
                    employeeRole: item.employee_role,
                };
            });
            setEmployees(data);
        } else {
            setEmployees([]);
        }
    }, [allEmployees]);

    useEffect(() => {
    if (!props.fromCAP || !props.selectedEmployee?.employee_number || !allEmployees?.data?.length) return;

    const match = allEmployees.data.find(
        (emp: any) => String(emp.employee_number) === String(props.selectedEmployee?.employee_number)
    );

    if (match) {
        setSelectedEmployee({
            employeeName:     match.employee_name,
            employeeNumber:   match.employee_number,
            employeeRole:     match.employee_role,
            employee_role_id: match.employee_role_id,
            country_name:     match.country_name,
            supervisorName:   match.supervisor_name?.split('(')[0] || '',
        });
        setSelectedCountry(match.country_id);
        setShowDetails(true);
    }
}, [allEmployees, props.fromCAP]);

    useEffect(() => {
        if (!props.fromCAP || !categories?.length) return;

        const performanceCategory = categories.find(
            (cat: any) => cat.ca_category_name?.toLowerCase() === 'performance'
        );
        if (performanceCategory) {
            setSelectedCategory(performanceCategory.ca_category_id);
        }
    }, [props.fromCAP, categories]);

    useEffect(() => {
        if (!props.fromCAP || !sevierityLevel?.length) return;

        const lowestSeverity = sevierityLevel.reduce((min: any, level: any) =>
            level.severity_level_id < min.severity_level_id ? level : min
            , sevierityLevel[0]);

        if (lowestSeverity && lowestSeverity.severity_level_id !== 0) {
            setSelectedSeverityLevel(lowestSeverity.severity_level_id);
        }
    }, [props.fromCAP, sevierityLevel]);

    useEffect(() => {
        setCategories(allCategories?.data?.length > 0 ? allCategories.data : []);
    }, [allCategories]);
    useEffect(() => {
        let vallSubCategories = [];
        if (allSubCategories?.data?.length > 0) {
            if (props.type === 'add') {
                vallSubCategories = allSubCategories.data.filter((item: any) => item.status === true);
            } else {
                vallSubCategories = allSubCategories.data;
            }
        }

        setSubcategories(vallSubCategories);
    }, [allSubCategories]);

    useEffect(() => {
        if (misconductData?.data?.length > 0) {
            const misconductList = misconductData.data.map((item: any) => ({
                ca_misconduct_id: item.ca_misconduct_id,
                ca_misconduct_name: item.ca_misconduct_name,
            }));
            setMisconduct(misconductList);
        } else {
            setMisconduct([]);
        }
    }, [misconductData]);

    useEffect(() => {
        setSevierityLevel(allsevierityLevel?.data?.length > 0 ? allsevierityLevel.data : []);
    }, [allsevierityLevel]);

    useEffect(() => {
        if (allLanguages?.data?.length > 0) {
            setLanguages(allLanguages?.data);
            if (
                props.type === 'add' ||
                ((!selectedLanguage || selectedCategory !== correctiveActionView?.data[0]?.ca_category_id) &&
                    props.type === 'update' &&
                    status === CaStatusNames.Draft)
            )
                setSelectedLanguage(allLanguages?.data[0]?.default_emp_language_id);
        }
    }, [allLanguages]);

    useEffect(() => {
        if (correctiveActionView?.data.length > 0) {
            const creationDate = new Date(correctiveActionView?.data[0]?.create_date);
            setNewStartDate(new Date(creationDate));
        }
        const noticeTxt = correctiveActionView?.data[0]?.notice_text?.replace('"', '')?.replace(/\\n/g, '\n');
        setNotice(noticeTxt);
        setNoticeDescription(noticeTxt);
        setSelectedCategory(correctiveActionView?.data[0]?.ca_category_id);
        setSelectedSubCategory(correctiveActionView?.data[0]?.ca_subcategory_id);
        setSelectedMisconduct(correctiveActionView?.data[0]?.ca_misconduct_id);
        setSelectedSeverityLevel(correctiveActionView?.data[0]?.severity_level_id);
        setSelectedCountry(props.selectedEmployee?.country_id);

        const obj = {
            employeeName: props.selectedEmployee?.employee_name,
            employeeNumber: props.selectedEmployee?.employee_number,
            employeeRole: props.selectedEmployee?.scorecard_role_name,
            employee_role_id: props.selectedEmployee?.scorecard_role_id
                ? props.selectedEmployee?.scorecard_role_id
                : correctiveActionView?.data[0]?.scorecard_role_id,
            country_name: props.selectedEmployee?.country_name,
            supervisorName: props.selectedEmployee?.supervisor_name
                ? props.selectedEmployee?.supervisor_name
                : props.selectedEmployee?.author_employee_name?.split('(')[0] || '',
            authorEmployeeName: props.selectedEmployee?.author_employee_name,
            authorEmployeeNumber: props.selectedEmployee?.author_employee_number,
        };
        setSelectedEmployee(obj);
        setStatus(correctiveActionView?.data[0]?.ca_status_name);
        setStatusId(correctiveActionView?.data[0]?.ca_status_id);
        setComments(correctiveActionView?.data[0]?.approval_action_comment);
        setSelectedLanguage(correctiveActionView?.data[0]?.emp_language_id);
        setDescription(correctiveActionView?.data[0]?.description);
        setIssuedDuringTraining(correctiveActionView?.data[0]?.in_training);
        if (props.type !== 'add') {
            setCorrectiveActionId(props.selectedEmployee?.corrective_action_id ?? 0);
        }
        switch (correctiveActionView?.data[0]?.ca_status_name) {
            case CaStatusNames.Acknowledged:
            case CaStatusNames.Approved:
            case CaStatusNames.Release:
            case CaStatusNames.AutoClosed:
                setIcon(CreatedTemplateIcon);
                break;
            case CaStatusNames.Rejected:
                setIcon(ErrorIcon);
                break;
            case CaStatusNames.ApprovalPending:
            case CaStatusNames.Draft:
            case CaStatusNames.Recalled:
                setIcon(WarningIcon);
                break;
            default:
                break;
        }
        disableValues();
    }, [correctiveActionView]);

    useEffect(() => {
        if (props.type === 'add' || (props.type === 'update' && status === CaStatusNames.Draft)) {
            const categroy = categories.find((item: any) => item.ca_category_id === selectedCategory);
            const severityLevel = sevierityLevel.find(
                (item: any) => item.severity_level_id === selectedSeverityLevel
            );
            let noticeText: string;
            if (noticeData?.data.length > 0) {
                noticeText = noticeData?.data[0]?.template_notice_text;
                setNoticeDetails(noticeData?.data[0]);
            } else {
                noticeText = '';
                setNoticeDetails({});
            }
            const date = DateTemplate(newStartDate);
            const replacements: any = {
                '<RECIPIENT NAME>': selectedEmployee?.employeeName || '',
                '<EMPLOYEE NUMBER>': selectedEmployee?.employeeNumber,
                '<SUPERVISOR NAME>': selectedEmployee?.supervisorName
                    ? selectedEmployee?.supervisorName
                    : selectedEmployee?.supervisor_name,
                '<SEVERITY LEVEL>': severityLevel ? severityLevel.severity_level_name : '',
                '<CATEGORY>': categroy ? categroy.ca_category_name : '',
                '<DESCRIPTION>': description || '<DESCRIPTION>',
                '<LATEST CA DATE IN CATEGORY>': noticeData?.data[0]
                    ? noticeData?.data[0]?.latestCADateInCategoryValue
                    : '<LATEST CA DATE IN CATEGORY>',
                '<CREATION DATE>': date.props.children,
            };
            if (noticeText) {
                Object.keys(replacements).forEach((e) => {
                    if (noticeText.includes(e)) {
                        noticeText = noticeText.replace(new RegExp(e, 'g'), replacements[e]);
                    }
                });
                setNotice(noticeText);
            } else {
                setDescription(description || '');
                setNotice('');
            }
        }
    }, [noticeData, notice]);

    useEffect(() => {
        if (selectedCategory && ((statusId === CaStatus.Draft && !props.view) || statusId === undefined)) {
            const level = allsevierityLevel?.data.length > 0 ? [...allsevierityLevel.data] : [];
            let severityLevelOfCategory = [];
            let ignoreLeveldelete: any = null;
            let highestSeverityLevelId = 0;
            const inTraining = issuedDuringTraining || false;
            severityLevelOfCategory = caMangerTlData?.data.filter(
                (correctiveAction: any) =>
                    correctiveAction.ca_category_id === selectedCategory &&
                    correctiveAction.expired !== true &&
                    (correctiveAction.ca_status_name === CaStatusNames.Draft ||
                        correctiveAction.ca_status_name === CaStatusNames.ApprovalPending ||
                        correctiveAction.ca_status_name === CaStatusNames.Approved ||
                        correctiveAction.ca_status_name === CaStatusNames.Release ||
                        correctiveAction.ca_status_name === CaStatusNames.Acknowledged) &&
                    correctiveAction.in_training === inTraining // Filter by in_training flag
            );

            if (severityLevelOfCategory?.length > 0) {
                highestSeverityLevelId = severityLevelOfCategory[0].severity_level_id;
                severityLevelOfCategory.forEach((correctiveAction: { severity_level_id: number }) => {
                    if (correctiveAction.severity_level_id > highestSeverityLevelId) {
                        highestSeverityLevelId = correctiveAction.severity_level_id;
                    }
                });
            }
            if (
                props.type === 'update' &&
                selectedCategory === correctiveActionView?.data[0]?.ca_category_id
            ) {
                const index = severityLevelOfCategory?.findIndex(
                    (correctiveAction: any) =>
                        correctiveAction.corrective_action_id === props.selectedEmployee?.corrective_action_id
                );
                if (index > -1) {
                    ignoreLeveldelete = severityLevelOfCategory[index]?.severity_level_id;
                    severityLevelOfCategory.splice(index, 1);
                }
            }
            const availbleSeverity = level.filter((level) => {
                return (
                    level.severity_level_id > highestSeverityLevelId ||
                    (ignoreLeveldelete !== null && level.severity_level_id === ignoreLeveldelete)
                );
            });
            const existSL = availbleSeverity?.filter((sl) => sl.severity_level_id === selectedSeverityLevel);
            if (existSL.length === 0) {
                setSelectedSeverityLevel('');
            }
            if (availbleSeverity.length === 0) {
                const noSeverity = [
                    {
                        severity_level_id: 0,
                        severity_level_name: 'No Severity Levels available',
                        disabled: true,
                    },
                ];
                setSevierityLevel(noSeverity);
            } else {
                setSevierityLevel(availbleSeverity);
            }
        }
    }, [
        selectedCategory,
        allsevierityLevel,
        caMangerTlData,
        selectedEmployee,
        correctiveActionView,
        issuedDuringTraining,
    ]);

    const disableValues = () => {
        const status = correctiveActionView?.data[0]?.ca_status_name;
        if ((props.type === 'update' && status !== CaStatusNames.Draft) || props.view) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    };

    const handleDescriptionChange = (value: string) => {
        setDescription(value);
    };

    const createdSuccessTempDialogFuncMap = {
        createdSuccessTempDialogBox: setCreatedSuccessTempdialogVisible,
    };

    const askCreateTempDialogFuncMap = {
        askCreateTempDialogBox: setAskcreateTempDialogVisible,
    };

    const onCreatedSuccessTempDialogBoxHide = () => {
        createdSuccessTempDialogFuncMap.createdSuccessTempDialogBox(false);
    };

    const generateData = () => {
        let updateNotice = '';
        const replacements: any = {
            '<DESCRIPTION>': description || '<Description>',
        };
        Object.keys(replacements).forEach((e) => {
            if (notice.includes(e)) {
                updateNotice = notice.replace(new RegExp(e, 'g'), replacements[e]);
            } else {
                updateNotice = notice;
            }
        });

        const formData = new FormData();

        if (selectedEmployee.employeeNumber != null)
            formData.append('employee_number', String(selectedEmployee.employeeNumber));

        if (selectedCategory != null) formData.append('category_id', String(selectedCategory));

        if (selectedSubCategory != null) formData.append('sub_category_id', String(selectedSubCategory));

        if (selectedMisconduct != null) formData.append('misconduct_id', String(selectedMisconduct));

        if (selectedSeverityLevel != null)
            formData.append('severity_level_id', String(selectedSeverityLevel));

        const scRoleId =
            status === CaStatusNames.Draft || status === CaStatusNames.Rejected
                ? noticeData?.data[0]?.scorecard_role_id
                : noticeDetails.scorecard_role_id || 0;
        formData.append('sc_role_id', String(scRoleId));

        if (loggedEmpNum != null) formData.append('author_emp_no', String(loggedEmpNum));

        formData.append('ca_status_id', String(isSave ? CaStatus.Draft : CaStatus.ApprovalPending));

        if (description != null) formData.append('desc', description);

        if (updateNotice != null) formData.append('notice_text', updateNotice);

        const caTemplateId =
            status === CaStatusNames.Draft || status === CaStatusNames.Rejected
                ? noticeData?.data[0]?.ca_template_id
                : noticeDetails.ca_template_id;
        if (caTemplateId != null) formData.append('ca_template_id', String(caTemplateId));

        const caTemplateNoticeId =
            status === CaStatusNames.Draft || status === CaStatusNames.Rejected
                ? noticeData?.data[0]?.ca_template_notice_id
                : noticeDetails.ca_template_notice_id;
        if (caTemplateNoticeId != null) formData.append('ca_template_notice_id', String(caTemplateNoticeId));

        if (selectedLanguage != null) formData.append('emp_lang_id', String(selectedLanguage));

        // Send null as string or skip if backend expects actual nulls as missing fields
        // formData.append('delegation_id', '');

        if (correctiveActionId != null) formData.append('corrective_action_id', String(correctiveActionId));

        formData.append('in_training', issuedDuringTraining === true ? 'true' : 'false');

        // Append uploaded files
        if (Array.isArray(uploadFiles)) {
            uploadFiles.forEach((file) => {
                if (file instanceof Blob) {
                    formData.append('FormFiles', file);
                }
            });
        }

        return formData;
    };

    const updateCorrectiveAction = (correctiveAction: any) => {
        UpdateCorrectiveAction(correctiveAction)
        .unwrap()
        .then((response: any) => {
            toast.success('Success');
            setStatusId(response?.data[0]?.ca_status_id);
            if (props.via === 'scorecardDashboard') {
                props.handleCloseDialog?.();
            }
        })
        .then((error: any) => {
            if (error) toast.error('Error');
        });
    };

    const createConfigurated = (correctiveAction: any) => {
        AssignCorrectiveAction(correctiveAction)
            .unwrap()
            .then((response: any) => {
                if (response?.data !== -1) {
                    const newCorrectiveActionId = response.data;

                    if (isSave) {
                        setSuccessMessage('Corrective action has been successfully saved as draft');
                        setAskcreateTempDialogVisible(false);
                        setCreatedSuccessTempdialogVisible(true);
                        setCorrectiveActionId(newCorrectiveActionId);
                        setSuccessHeader('Saved!');
                    } else {
                        setSuccessMessage('Corrective action has been successfully submitted');
                        setAskcreateTempDialogVisible(false);
                        setCreatedSuccessTempdialogVisible(true);
                        setSuccessHeader('Submitted!');
                    }

                    if (props.fromCAP && props.coachingActionPlanId && newCorrectiveActionId && newCorrectiveActionId > 0) {
                        linkCorrectiveActionToCap({
                            coaching_action_plan_id: props.coachingActionPlanId,
                            corrective_action_id: newCorrectiveActionId,
                        })
                            .unwrap()
                            .then(() => {
                                toast.success('Corrective action linked to coaching plan.');
                                if (props.scorecardVersionId && props.selectedEmployee?.employee_number) {
                                    calculateNextBestAction({
                                        scorecardVersionId: props.scorecardVersionId,
                                        employeeNumber: String(props.selectedEmployee.employee_number),
                                    }).unwrap().catch((nbaError: unknown) => {
                                        console.error('NBA recalculation failed:', nbaError);
                                    });
                                }
                            })
                            .catch(() => toast.error('Failed to link corrective action to coaching plan.'));
                    }

                } else {
                    setAskcreateTempDialogVisible(false);
                    toast.error('Error saving the Corrective action');
                }
            })
            .catch((error: any) => console.log(error));
    };

    const handleUpdate = async (status: number, approvalActionId?: number) => {
        const update = {
            corrective_action_id: correctiveActionId,
            employee_number: parseInt(loggedEmpNum, 10),
            ca_status_id: status,
            ca_approval_action_id: approvalActionId,
            ca_approval_action_comment: comments,
        };
        updateCorrectiveAction(update);
    };

    const handleSave = async () => {
        setIsSave(true);
        if (
            !selectedCategory ||
            !(selectedSubCategory || selectedMisconduct) ||
            !selectedLanguage ||
            !selectedSeverityLevel ||
            !description ||
            !notice
        ) {
            toast.error('Invalid Corrective Assignment values');
        } else {
            setWarningMessage('Are you sure you want to save this corrective action as draft?');
            setAskcreateTempDialogVisible(true);
        }
    };

    const handleSubmit = () => {
        setIsSave(false);
        if (
            !selectedCategory ||
            !(selectedSubCategory || selectedMisconduct) ||
            !selectedLanguage ||
            !selectedSeverityLevel ||
            !description ||
            !notice
        ) {
            toast.error('Invalid Corrective Assignment values');
        } else {
            setWarningMessage('Are you sure you want to submit this corrective action?');
            setAskcreateTempDialogVisible(true);
        }
    };

    const handleClickYes = async () => {
        const data = await generateData();
        createConfigurated(data);
    };

    const onAskCreateTempDialogBoxHide = () => {
        askCreateTempDialogFuncMap.askCreateTempDialogBox(false);
    };

    const handleClickCancel = () => {
        onAskCreateTempDialogBoxHide();
    };

    const handleClickReturn = () => {
        onCreatedSuccessTempDialogBoxHide();
        setTimeout(() => {
            props.setActiveIndex?.(AssignmentTabIndex.Dashboard);
        }, 100);
    };

    const createFooterTemplate = (
        <div className="row">
            <div className="col-md-2">&nbsp;</div>
            <div className="col-md-4">
                <Button
                    className="btn-secondary w-100"
                    onClick={handleClickCancel}
                    label={'Cancel'}
                />
            </div>
            <div className="col-md-4">
                <Button className="btn-primary w-100" onClick={handleClickYes} label={'Yes'} />
            </div>
            <div className="col-md-2">&nbsp;</div>
        </div>
    );

    const CreatedSuccessfooterTemplate = (
        <div className="row flex justify-content-center ">
            <div className="col-md-6">
                <Button
                    className="btn-primary w-100"
                    onClick={handleClickReturn}
                    label={'Continue'}
                />
            </div>
        </div>
    );

    const draftStatusDescription = () => {
        const categroy = categories.find((item: any) => item.ca_category_id === selectedCategory);
        const severityLevel = sevierityLevel.find(
            (item: any) => item.severity_level_id === selectedSeverityLevel
        );
        let noticeText: string;
        if (noticeData?.data.length > 0) {
            noticeText = noticeData?.data[0]?.template_notice_text?.replace('"', '');
            setNoticeDetails(noticeData?.data[0]);
        } else {
            noticeText = '';
            setNoticeDetails({});
        }
        const date = DateTemplate(newStartDate);
        const replacements: any = {
            '<RECIPIENT NAME>': selectedEmployee?.employeeName || '',
            '<EMPLOYEE NUMBER>': selectedEmployee?.employeeNumber,
            '<SUPERVISOR NAME>': selectedEmployee?.supervisorName
                ? selectedEmployee?.supervisorName
                : selectedEmployee?.supervisor_name,
            '<SEVERITY LEVEL>': severityLevel ? severityLevel.severity_level_name : '',
            '<CATEGORY>': categroy ? categroy.ca_category_name : '',
            '<DESCRIPTION>': description || '<DESCRIPTION>',
            '<LATEST CA DATE IN CATEGORY>': noticeData?.data[0]
                ? noticeData?.data[0]?.latestCADateInCategoryValue
                : '<LATEST CA DATE IN CATEGORY>',
            '<CREATION DATE>': date.props.children,
        };
        if (noticeText) {
            Object.keys(replacements).forEach((e) => {
                if (noticeText.includes(e)) {
                    noticeText = noticeText.replace(new RegExp(e, 'g'), replacements[e]);
                }
            });
            setNotice(noticeText);
            setNoticeDescription(noticeText);
        } else if (props.view) {
            setNoticeDescription(noticeDescription || '');
            setNotice(notice || '');
        } else {
            setNoticeDescription('');
            setNotice('');
        }
    };
    useEffect(() => {
        if (props.type === 'add' || (props.type === 'update' && status === CaStatusNames.Draft)) {
            draftStatusDescription();
        }
    }, [description, noticeData, selectedEmployee?.employeeNumber]);
    const formatText = (text: string) => {
        return text?.replaceAll('<br>', '\n');
    };
    const handleFilesSelected = (files: File[]) => {
        setUploadFiles(files);
    };

    const handleDeleteFile = (file: CorrectiveActionDocument) => {
        DeleteCaDocument({
            ca_document_id: file.ca_document_id!,
            ca_document_name: file.ca_document_name!,
        })
        .unwrap()
        .then(() => {
            toast.success('Document deleted successfully');
        })
        .catch(() => {
            toast.error('Failed to delete document');
        });
    };

    useEffect(() => {
        if (loggedEmpNum === props.selectedEmployee?.author_employee_number) {
            setUserCanDeleteFiles(true);
        } else {
            setUserCanDeleteFiles(false);
        }
    }, [loggedEmpNum, props.selectedEmployee?.author_employee_number]);

    useEffect(() => {
        if (employeeData?.data?.length > 0) {
            const empData = employeeData.data[0];
            const obj = {
                employeeName: empData?.employee_name,
                employeeNumber: empData?.employee_number,
                employeeRole: empData?.employee_role,
                employee_role_id: empData?.employee_role_id,
                country_name: empData?.country_name,
                authorEmployeeName: loggedUser,
                authorEmployeeNumber: loggedEmpNum,
                supervisorName: empData?.supervisor_name?.split('(')[0] || '',
            };
            setSelectedEmployee(obj);
            setSelectedCountry(empData?.country_id);
            setShowDetails(true);
            setNoticeDescription('');
            if (obj?.employee_role_id !== 1 && obj?.employee_role_id !== 2)
                toast.warning('No template available.');
        } else if (isHC && selectedEmployeeNoByHC) {
            setSelectedEmployee(null);
            setShowDetails(false);
        }
    }, [employeeData]);

    const resetAllFilters = () => {
        setSelectedEmployee(null);
        setSelectedCountry('');
        setSelectedCategory('');
        setSelectedSubCategory('');
        setShowDetails(false);
        setNoticeDescription('');
    };

    const handleCommentsChange = (value: string) => {
        setComments(value);
    };

    return (
        <>
            {!props.view && <h6 className="m-top-30">Recipient Information</h6>}
            {!props.view && props.via === 'tab' && !isHC && (
                <div className="row">
                    <div className="col-md-3">
                        <div className="content" style={{ width: 'fit-content' }}>
                            <label htmlFor="employeeId">Employee</label>
                            <Dropdown
                                id="employeeId"
                                filter
                                placeholder="Select Employee"
                                className="custom-dropdown"
                                options={employees}
                                optionValue={'employee_number'}
                                optionLabel={'employee_name'}
                                value={selectedEmployee?.employeeNumber}
                                disabled={props.fromCAP} 
                                onChange={(e: any) => {
                                    const data = employees?.find(
                                        (employee: any) => employee.employeeNumber === e.value
                                    );
                                    setSelectedEmployee(data);
                                    setSelectedCountry(data.country_id);
                                    setShowDetails(true);
                                    setNoticeDescription('');
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
            {!props.view && props.via === 'tab' && isHC && (
                <div className="row">
                    <div className="col-md-12">
                        <EmployeeFilter
                            resetDate={resetAllFilters}
                            setAgentNumber={setSelectedEmployeeNoByHC}
                        />
                    </div>
                </div>
            )}
            {showDetails && (
                <>
                    {' '}
                    <div className="row mt-4 pb-2">
                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="recipientName">Recipient Name</label>
                                <InputText
                                    disabled
                                    placeholder="Recipient Name"
                                    value={selectedEmployee ? selectedEmployee.employeeName : ''}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="countryId">Country</label>
                                <InputText
                                    disabled
                                    placeholder="Country"
                                    value={selectedEmployee ? selectedEmployee.country_name : ''}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="roleId">Role</label>
                                <InputText
                                    placeholder="Role"
                                    disabled
                                    value={selectedEmployee ? selectedEmployee.employeeRole : ''}
                                />
                            </div>
                        </div>
                    </div>
                    <Divider />
                    <h6 className="m-top-30">Corrective Action Information</h6>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="recipientName">Author</label>

                                <InputText
                                    disabled
                                    value={`${
                                        selectedEmployee?.authorEmployeeName !== undefined
                                            ? selectedEmployee?.authorEmployeeName
                                            : loggedUser
                                    } `}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="countryId">Creation Date</label>
                                <Calendar
                                    id="basic"
                                    disabled
                                    value={newStartDate}
                                    showIcon
                                    className="custom-calendar mb-4"
                                    dateFormat="dd-M-yy"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {props.type !== 'add' && (
                            <div className="col-md-3 me-5">
                                <h6 className="m-top-20">Status</h6>
                                <div className="status-container">
                                    <img className="status-icon" src={icon} alt="icons" />
                                    <p className="m-0">{status}</p>
                                </div>
                            </div>
                        )}
                        <div
                            className="col-md-5"
                            style={{ marginTop: '25px', display: 'flex' }}
                            hidden={
                                !issuedDuringTraining ||
                                status === CaStatusNames.Draft ||
                                props.type === 'add'
                            }
                        >
                            <img className="status-icon" src={CreatedTemplateIcon} alt="icons" />
                            <p style={{ marginLeft: '5px' }}>Issued during training</p>
                        </div>

                        {selectedEmployee?.employeeRole === 'Associate' &&
                            ((props.type === 'add' && !props.view) ||
                                (props.type === 'update' && status === CaStatusNames.Draft)) && (
                                <div
                                    className="col-md-3 mb-3"
                                    style={{
                                        marginTop: props.type !== 'add' ? '25px' : '0px',
                                        marginBottom: '10px',
                                    }}
                                >
                                    <Checkbox
                                        inputId="acknowledge"
                                        className="me-2"
                                        disabled={disabled}
                                        value="Acknowledged"
                                        checked={issuedDuringTraining}
                                        onChange={(e) => {
                                            setIssuedDuringTraining(e.target.checked);
                                        }}
                                    />
                                    <label htmlFor="acknowledge">Issued during Training</label>
                                </div>
                            )}
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="recipientName">Category</label>
                                <Dropdown
                                    id="recipientName"
                                    filter
                                    placeholder="Select Category"
                                    className="custom-dropdown"
                                    options={categories}
                                    disabled={disabled}
                                    optionValue={'ca_category_id'}
                                    optionLabel={'ca_category_name'}
                                    value={selectedCategory}
                                    onChange={(e) => {
                                        setSubcategories(null);
                                        setMisconduct([]);
                                        setSelectedCategory(e.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {misconductData?.data?.length > 0 ? (
                            <div className="col-md-3">
                                <div className="content">
                                    <label htmlFor="countryId">Misconduct</label>
                                    <Dropdown
                                        id="countryId"
                                        filter
                                        placeholder="Select Misconduct"
                                        className="custom-dropdown"
                                        disabled={disabled}
                                        options={misconduct}
                                        optionValue={'ca_misconduct_id'}
                                        optionLabel={'ca_misconduct_name'}
                                        value={selectedMisconduct}
                                        onChange={(e: any) => {
                                            setSelectedMisconduct(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="col-md-3">
                                <div className="content">
                                    <label htmlFor="countryId">Sub Category</label>
                                    <Dropdown
                                        id="countryId"
                                        filter
                                        placeholder="Select sub category"
                                        className="custom-dropdown"
                                        disabled={disabled}
                                        options={subCategories}
                                        optionValue={'ca_subcategory_id'}
                                        optionLabel={'ca_subcategory_name'}
                                        value={selectedSubCategory}
                                        onChange={(e: any) => {
                                            setSelectedSubCategory(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="sevierityLevelId">Severity Level</label>
                                <Dropdown
                                    id="sevierityLevelId"
                                    filter
                                    placeholder="Select Severity Level"
                                    className="custom-dropdown"
                                    disabled={disabled}
                                    options={sevierityLevel}
                                    optionValue={'severity_level_id'}
                                    optionLabel={'severity_level_name'}
                                    value={selectedSeverityLevel}
                                    onChange={(e) => {
                                        setSelectedSeverityLevel(e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="content">
                                <label htmlFor="countrydd">Language*</label>
                                <Dropdown
                                    id="emp_language_id"
                                    placeholder="Select"
                                    className="custom-dropdown"
                                    options={languages}
                                    disabled={disabled}
                                    optionValue={'emp_language_id'}
                                    optionLabel={'emp_language_name'}
                                    value={selectedLanguage}
                                    onChange={(e: any) => {
                                        setSelectedLanguage(e.value);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {((props.type === 'add' && !props.view) ||
                        (props.type === 'update' && status === CaStatusNames.Draft)) && (
                        <div className="flex justify-content-center m-top-15">
                            <DescriptionBox
                                disabled={!notice}
                                createdByLabel="Author"
                                createdByValue={loggedUser}
                                title="Description*"
                                responseDescription={description}
                                value={description}
                                limit={4000}
                                onChange={handleDescriptionChange}
                            />
                        </div>
                    )}
                    <h6 className="m-top-30">Notice</h6>
                    {(props.type === 'add' && !props.view) ||
                    (props.type === 'update' && status === CaStatusNames.Draft) ? (
                        <p style={{ whiteSpace: 'break-spaces' }}>{formatText(noticeDescription)}</p>
                    ) : (
                        <p style={{ whiteSpace: 'break-spaces' }}>{formatText(notice)}</p>
                    )}
                    {!notice &&
                        selectedCategory &&
                        selectedSeverityLevel &&
                        selectedLanguage &&
                        !isLoadingCorrectiveActionView &&
                        props.type !== 'update' && <p className="no-notice">No template available</p>}
                    {props.type === 'ack' && statusId === CaStatus.Release && (
                        <div className="flex justify-content-center m-top-15">
                            <DescriptionBox
                                createdByLabel="Author"
                                createdByValue={loggedUser}
                                title="Comments*"
                                responseDescription={comments}
                                value={comments}
                                limit={4000}
                                onChange={handleCommentsChange}
                            />
                        </div>
                    )}
                </>
            )}
            {correctiveActionId > 0 && files.length > 0 && (
                <div>
                    {
                        <MultiFileViewer
                            files={files}
                            loading={isLoading}
                            allowDelete={userCanDeleteFiles} // boolean — ex: currentUser.Id === file.UploadedByUserId
                            onDelete={(file) => handleDeleteFile(file)}
                        />
                    }
                </div>
            )}
            {props.type !== 'ack' && !props.view && (
                <>
                    {(props.type === 'add' ||
                        (props.type === 'update' && status === CaStatusNames.Draft)) && (
                        <div>
                            <Dialog
                                header={
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#b91c1c' }}>
                                        <i className="pi pi-exclamation-circle" />
                                        File Upload Error
                                    </span>
                                }
                                visible={fileErrorDialogVisible}
                                style={{ width: '420px' }}
                                onHide={() => setFileErrorDialogVisible(false)}
                                footer={
                                    <Button
                                        label="OK"
                                        className="btn-primary"
                                        onClick={() => setFileErrorDialogVisible(false)}
                                        type="button"
                                    />
                                }
                            >
                                <ul style={{ margin: 0, paddingLeft: '20px', lineHeight: '1.8' }}>
                                    {fileErrors.map((err, i) => (
                                        <li key={i}>{err}</li>
                                    ))}
                                </ul>
                            </Dialog>
                            <MultiFileUploadPreview
                                onFilesSelected={handleFilesSelected}
                                onValidationError={(errors) => {
                                    setFileErrors(errors);
                                    setFileErrorDialogVisible(true);
                                }}
                            />
                        </div>
                    )}
                    <div className="m-t-20 row button-container">
                        {props.type === 'add' && (
                            <>
                                <Button
                                    type="button"
                                    className="btn-primary w-120 m-r-20"
                                    onClick={handleSave}
                                    disabled={!notice}
                                    label="Save"
                                />
                                <Button
                                    type="button"
                                    onClick={handleSubmit}
                                    disabled={!notice}
                                    label="Submit"
                                    className="btn-primary w-125"
                                />
                            </>
                        )}
                        {props.type === 'update' && (
                            <CaButton
                                authorId={correctiveActionView?.data[0]?.author_employee_number}
                                authorsManagerNumber={correctiveActionView?.data[0]?.authors_manager_number}
                                setActiveIndex={props.setActiveIndex}
                                handleCloseDialog={props.handleCloseDialog}
                                correctiveActionId={correctiveActionId}
                                employeeNumber={parseInt(loggedEmpNum, 10)}
                                status={status}
                                type={props.type}
                                selectedCategory={selectedCategory}
                                selectedSubCategory={selectedSubCategory}
                                selectedMisconduct={selectedMisconduct}
                                selectedSeverityLevel={selectedSeverityLevel}
                                notice={notice}
                                handleClickYes={handleClickYes}
                                setIsSave={setIsSave}
                                via={props.via}
                                supervisorNumber={correctiveActionView?.data[0]?.supervisor_number}
                                managerNumber={correctiveActionView?.data[0]?.manager_number}
                            />
                        )}
                    </div>
                </>
            )}

            {props.type === 'ack' && (
                <div className="row button-container">
                    {props.via === 'scorecardDashboard' ? (
                        <Button
                            type="button"
                            onClick={() => {
                                props.handleCloseDialog?.();
                            }}
                            style={{ width: '150px' }}
                            className="btn-secondary"
                            label="Close"
                        />
                    ) : (
                        <Button
                            type="button"
                            onClick={() => {
                                props.setActiveIndex?.(MyDashboardCA.Dashboard);
                            }}
                            // className="p-button w-200 m-r-20"
                            style={{ width: '150px' }}
                            className="btn-secondary"
                            label="Close"
                        />
                    )}
                    {statusId === CaStatus.Release && (
                        <Button
                            type="button"
                            onClick={() => handleUpdate(CaStatus.Acknowledged, CaApprovalAction.Acknowledged)}
                            className="btn-primary"
                            style={{ width: '170px' }}
                            label="Acknowledge"
                        />
                    )}
                </div>
            )}

            <CaHistory
                employeNumber={selectedEmployee}
                caId={correctiveActionId}
                showMisconduct={misconductData?.data?.length > 0}
            />

            <ControlDialogBox
                dialogVisibile={askcreateTempDialogVisible}
                IconPath={AskCreateTemplateIcon}
                footerTemplate={createFooterTemplate}
                subHeading={''}
                subHeadingColor={'#7D71E2'}
                msgText={warningMessage}
                onDialogBoxHide={onAskCreateTempDialogBoxHide}
            />
            <ControlDialogBox
                dialogVisibile={createdSuccessTempdialogVisible}
                footerTemplate={CreatedSuccessfooterTemplate}
                IconPath={CreatedTemplateIcon}
                subHeading={successHeader}
                subHeadingColor={'#64D96E'}
                msgText={successMessage}
                onDialogBoxHide={onCreatedSuccessTempDialogBoxHide}
            />
        </>
    );
};
